import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";

import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "./common/auth-interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: "enabled", // Scrolls to the anchor element when a fragment is present
        scrollPositionRestoration: "enabled", // Restores scroll position on back/forward navigation
      }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
